<template>
  <Nav />
  <div class="container" v-if="!exercicioSelected">
    <div class="container-exercicio" v-if="!exercicioSelected">
      <div
        class="exercicios-header align-left"
        v-if="!exercicioSelected && availableYears.length > 0 && !isLoadingPage"
      >
        <h1 class="h3 mb-3 poppins-light">
          Selecione o
          <span class="poppins-semibold">Exercício do Balancete</span>
        </h1>
      </div>
      <div
        class="exercicios-list"
        v-if="!exercicioSelected && availableYears.length > 0 && !isLoadingPage"
      >
        <ul class="list-group">
          <li
            v-for="year in availableYears"
            :key="year"
            class="list-group-item"
          >
            <a href="#" @click.prevent="selectYear(year)">
              {{ year }}
              <i class="bi bi-arrow-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <div
        class="no-exercicios-message"
        v-if="
          availableYears.length === 0 && !exercicioSelected && !isLoadingPage
        "
      >
        <h4 class="poppins-light">
          Não há dados de balancetes para este município
        </h4>
      </div>
    </div>
  </div>

  <div class="container-fluid" v-if="exercicioSelected" @click="showComponentModal && closeComponentModal()">
    <!-- Header Section -->
    <div class="balancetes-header" v-if="exercicioSelected">
      <div class="d-flex align-items-center gap-3">
        <a href="#" class="h3" @click.prevent="goBack">
          <i class="bi bi-arrow-left"></i>
        </a>
        <div>
          <h3 class="poppins-light mb-0">Balancetes</h3>
          <p class="h5 poppins-light text-muted mb-0">
            {{ cidadeSelected }} - Exercício {{ exercicio }}
          </p>
        </div>
      </div>
      <div class="d-flex gap-2">
        <button
          class="btn btn-outline-secondary"
          @click="refreshData"
          :disabled="isLoading"
        >
          <i class="bi bi-arrow-clockwise"></i> Atualizar
        </button>
        <button
          class="btn btn-secondary"
          @click.prevent="streamExportData"
          :disabled="isLoading || balancetes.length === 0"
        >
          <i class="bi bi-download"></i> Exportar
        </button>
      </div>
    </div>

    <div class="container-exercicio" v-if="!exercicioSelected">
      <!-- Year Selection -->
      <div
        class="exercicios-header align-left"
        v-if="!exercicioSelected && availableYears.length > 0 && !isLoadingPage"
      >
        <h1 class="h3 mb-3 poppins-light">
          Selecione o
          <span class="poppins-semibold">Exercício do Balancete</span>
        </h1>
      </div>
      <div
        class="exercicios-list"
        v-if="!exercicioSelected && availableYears.length > 0 && !isLoadingPage"
      >
        <ul class="list-group">
          <li
            v-for="year in availableYears"
            :key="year"
            class="list-group-item"
          >
            <a href="#" @click.prevent="selectYear(year)">
              {{ year }}
              <i class="bi bi-arrow-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <div
        class="no-exercicios-message"
        v-if="
          availableYears.length === 0 && !exercicioSelected && !isLoadingPage
        "
      >
        <h4 class="poppins-light">
          Não há dados de balancetes para este município
        </h4>
      </div>
    </div>

    <!-- Data Table Section -->
    <div class="data-section" v-if="exercicioSelected && !isLoadingPage">
      <!-- Filters Toggle and Month Selector -->
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <div>
          <button
            class="btn btn-sm btn-outline-secondary"
            @click="showFilters = !showFilters"
          >
            <i :class="showFilters ? 'bi bi-funnel-fill' : 'bi bi-funnel'"></i>
            Filtros
            <span v-if="hasActiveFilters" class="badge bg-primary ms-1">{{
              activeFiltersCount
            }}</span>
          </button>
          <button
            class="btn btn-sm btn-outline-danger ms-2"
            @click="clearDynamicFilters"
            v-if="hasActiveFilters"
          >
            <i class="bi bi-x-circle"></i> Limpar
          </button>
        </div>
        
        <!-- Month selector -->
        <div class="d-flex align-items-center gap-2">
          <label class="form-label small mb-0 text-muted">Mês:</label>
          <select
            class="form-select form-select-sm"
            v-model="mes"
            @change="onMonthChange"
            :disabled="isLoading || availableMonths.length === 0"
            style="min-width: 120px;"
          >
            <option value="">Selecionar mês</option>
            <option
              v-for="month in availableMonths"
              :key="month.value"
              :value="month.value"
            >
              {{ month.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- Dynamic Filters Panel (Collapsible) -->
      <div class="card mb-4" v-show="showFilters">
        <div class="card-body py-3">
          <!-- Global Search -->
          <div class="row g-3 mb-3">
            <div class="col-md-4">
              <label class="form-label small">Busca global</label>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Buscar em todos os campos..."
                v-model="searchTerm"
                @input="debounceSearch"
              />
            </div>
            <div class="col-md-8 d-flex align-items-end">
              <button
                class="btn btn-outline-primary btn-sm me-2"
                @click="addFilter"
              >
                <i class="bi bi-plus"></i> Adicionar Filtro
              </button>
              <button
                class="btn btn-outline-secondary btn-sm me-2"
                @click="applyDynamicFilters"
                :disabled="!hasValidFilters"
              >
                <i class="bi bi-funnel"></i> Aplicar Filtros
              </button>
              <button
                class="btn btn-outline-danger btn-sm"
                @click="clearDynamicFilters"
                v-if="dynamicFilters.length > 1 || dynamicFilters[0].field"
              >
                <i class="bi bi-x-circle"></i> Limpar
              </button>
            </div>
          </div>

          <!-- Dynamic Filter Rows -->
          <div class="dynamic-filters">
            <div 
              v-for="(filter, index) in dynamicFilters" 
              :key="filter.id"
              class="filter-row mb-2"
            >
              <!-- Junction selector (not shown for first filter) -->
              <div class="row g-2 align-items-center" v-if="index > 0">
                <div class="col-md-1">
                  <select
                    class="form-select form-select-sm"
                    v-model="filter.junction"
                    @change="applyDynamicFilters"
                  >
                    <option value="E">E</option>
                    <option value="OU">OU</option>
                  </select>
                </div>
                <div class="col-md-11">
                  <hr class="my-1">
                </div>
              </div>

              <!-- Filter fields -->
              <div class="row g-2 align-items-center">
                <!-- Field selector -->
                <div class="col-md-3">
                  <select
                    class="form-select form-select-sm"
                    v-model="filter.field"
                    @change="onFilterFieldChange(filter)"
                  >
                    <option value="">Selecionar campo</option>
                    <option
                      v-for="field in filterFields"
                      :key="field.value"
                      :value="field.value"
                    >
                      {{ field.label }}
                    </option>
                  </select>
                </div>

                <!-- Operator selector -->
                <div class="col-md-3">
                  <select
                    class="form-select form-select-sm"
                    v-model="filter.operator"
                    @change="applyDynamicFilters"
                    :disabled="!filter.field"
                  >
                    <option value="">Selecionar operador</option>
                    <option
                      v-for="operator in getAvailableOperators(filter.field)"
                      :key="operator.value"
                      :value="operator.value"
                    >
                      {{ operator.label }}
                    </option>
                  </select>
                </div>

                <!-- Value input -->
                <div class="col-md-4">
                  <input
                    v-if="!isNullOperator(filter.operator)"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Valor"
                    v-model="filter.value"
                    @input="debounceFilterChange"
                    :disabled="!filter.operator"
                  />
                  <span v-else class="form-control form-control-sm bg-light text-muted">
                    (sem valor)
                  </span>
                </div>

                <!-- Remove button -->
                <div class="col-md-2">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    @click="removeFilter(index)"
                    :disabled="dynamicFilters.length === 1"
                    title="Remover filtro"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Filter Preview -->
          <div v-if="hasValidFilters" class="mt-3">
            <div class="alert alert-info py-2">
              <small class="text-muted d-block mb-1">Filtros aplicados:</small>
              <code class="small">{{ buildFilterPreview() }}</code>
            </div>
          </div>
        </div>
      </div>

      <!-- Data Table -->
      <div class="card">
        <div class="table-responsive">
          <table class="table table-hover table-sm table-compact mb-0">
            <thead class="table-light sticky-top">
              <tr>
                <th style="width: 12%">Máscara</th>
                <th class="text-center" style="width: 3.5%">PO</th>
                <th class="text-center" style="width: 3.5%">FP</th>
                <th class="text-center" style="width: 3.5%">DC</th>
                <th class="text-center" style="width: 3.5%">FR</th>
                <th class="text-center" style="width: 3.5%">CO</th>
                <th class="text-center" style="width: 3.5%">NR</th>
                <th class="text-center" style="width: 3.5%">ND</th>
                <th class="text-center" style="width: 3.5%">FS</th>
                <th class="text-center" style="width: 3.5%">AI</th>
                <th class="text-end" style="width: 12%">Saldo Anterior</th>
                <th class="text-center" style="width: 0%"></th>
                <th class="text-end" style="width: 10%">Débito</th>
                <th class="text-end" style="width: 10%">Crédito</th>
                <th class="text-end" style="width: 12%">Saldo Final</th>
                <th class="text-center" style="width: 0%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="16" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Carregando...</span>
                  </div>
                  <p class="mt-2 mb-0 small">Carregando dados...</p>
                </td>
              </tr>
              <tr v-else-if="balancetes.length === 0">
                <td colspan="16" class="text-center py-4 text-muted">
                  <i class="bi bi-inbox display-4"></i>
                  <p class="mt-2 mb-0">Nenhum registro encontrado</p>
                </td>
              </tr>
              <template
                v-else-if="balancetes && balancetes.length > 0"
                v-for="item in balancetes"
                :key="`${item.mascara}-${item.po || 'null'}-${item.fp || 'null'}`"
              >
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <code class="mascara-code">{{ item.mascara_formatada }}</code>
                      <a class="bi bi-info-circle ms-2" :title="item.descricao"></a>
                    </div>
                  </td>
                  <td class="text-center">
                    <button v-if="item.po" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'po', item.po)"
                            type="button">
                      {{ item.po }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.fp" 
                            class="component-btn" 
                            type="button"
                            @click.stop="showComponentDescription($event, 'fp', item.fp)">
                      {{ item.fp }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.dc" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'dc', item.dc)">
                      {{ item.dc }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.fr" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'fr', item.fr)">
                      {{ item.fr }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.co" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'co', item.co)">
                      {{ item.co }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.nr" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'nr', item.nr)">
                      {{ item.nr }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.nd" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'nd', item.nd)">
                      {{ item.nd }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.fs" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'fs', item.fs)">
                      {{ item.fs }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-center">
                    <button v-if="item.ai" 
                            class="component-btn" 
                            @click.stop="showComponentDescription($event, 'ai', item.ai)">
                      {{ item.ai }}
                    </button>
                    <small v-else class="text-muted">-</small>
                  </td>
                  <td class="text-end">
                    <span>{{ formatCurrency(item.saldo_anterior) }}</span>
                  </td>
                  <td class="nat-saldo-col" style="padding-left: 0 !important;">
                    <small class="text-muted">{{
                      item.nat_saldo_anterior || ""
                    }}</small>
                  </td>
                  <td class="text-end">
                    <span>{{ formatCurrency(item.debito) }}</span>
                  </td>
                  <td class="text-end">
                    <span>{{ formatCurrency(item.credito) }}</span>
                  </td>
                  <td class="text-end">
                    <span>{{ formatCurrency(item.saldo_final) }}</span>
                  </td>
                  <td class="nat-saldo-col" style="padding-left: 0 !important;">
                    <small class="text-muted">{{
                      item.nat_saldo_final || ""
                    }}</small>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="card-footer" v-if="pagination && pagination.totalPages > 1">
          <div class="d-flex justify-content-between align-items-center">
            <!-- Pagination Navigation -->
            <nav>
              <ul class="pagination mb-0 pagination-sm">
                <li
                  class="page-item"
                  :class="{ disabled: !pagination.hasPrev }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToPage(pagination.page - 1)"
                  >
                    <i class="bi bi-chevron-left"></i>
                  </a>
                </li>

                <li
                  v-for="page in getVisiblePages()"
                  :key="page"
                  class="page-item"
                  :class="{ active: page === pagination.page }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToPage(page)"
                    >{{ page }}</a
                  >
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: !pagination.hasNext }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="goToPage(pagination.page + 1)"
                  >
                    <i class="bi bi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>

            <!-- Rows per page selector -->
            <div class="d-flex align-items-center gap-2">
              <small class="text-muted">Por página:</small>
              <select
                class="form-select form-select-sm"
                style="width: auto"
                v-model="pageSize"
                @change="changePageSize"
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="250">250</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Overlay -->
    <div
      v-if="isLoadingPage"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px"
    >
      <div class="text-center">
        <div
          class="spinner-border text-primary mb-3"
          role="status"
          style="width: 3rem; height: 3rem"
        >
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p class="h5 text-muted">Carregando...</p>
      </div>
    </div>

    <!-- Export Progress Overlay -->
    <div
      v-if="exportProgress.show"
      class="export-progress-overlay"
    >
      <div class="export-progress-modal">
        <div class="text-center">
          <div 
            v-if="!exportProgress.isComplete"
            class="spinner-border text-primary mb-3"
            role="status"
            style="width: 2rem; height: 2rem"
          >
            <span class="visually-hidden">Exportando...</span>
          </div>
          <div 
            v-else
            class="text-success mb-3"
          >
            <i class="bi bi-check-circle-fill" style="font-size: 2rem;"></i>
          </div>
          <p class="h6 mb-0">{{ exportProgress.message }}</p>
          <small v-if="!exportProgress.isComplete" class="text-muted">
            Esta operação pode levar alguns minutos para grandes volumes de dados
          </small>
        </div>
      </div>
    </div>
  </div>
  <!-- <div> -->
    <!-- Component Description Modal -->
  <div v-if="showComponentModal" 
        ref="componentModal"
        id="componenteModalDescription"
        class="component-modal"
        @click.stop
        :style="{
          top: componentModalPosition.top + 'px',
          left: componentModalPosition.left + 'px'
        }">
    <div class="component-modal-header">
      <h6 class="mb-0">{{ componentModalTitle }}</h6>
      <button class="btn-close-modal" @click="closeComponentModal">
        <i class="bi bi-x"></i>
      </button>
    </div>
    <!-- <div class="component-modal-close">
      <button class="btn-close-modal" @click="closeComponentModal">
        <i class="bi bi-x"></i>
      </button>
    </div> -->
    <div class="component-modal-body">
      <p class="mb-0">{{ componentModalDescription }}</p>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import axiosApi from "@/axios";
import Nav from "@/components/Nav.vue";
import Cookies from "js-cookie";
import { mapActions, mapState } from "vuex";

export default {
  name: "Balancetes",
  components: {
    Nav,
  },
  data() {
    return {
      // State management
      isLoadingPage: true,
      isLoading: false,
      exercicioSelected: false,
      exercicio: "",
      mes: "",
      cidadeSelected: "",
      codigoSiconfi: "",
      showFilters: false,

      // Data
      availableYears: [],
      availableMonths: [],
      balancetes: [],
      pagination: null,

      // Filtering and searching
      searchTerm: "",
      searchTimeout: null,
      
      // Dynamic filters
      dynamicFilters: [
        {
          id: 1,
          field: '',
          operator: '',
          value: '',
          junction: 'E' // E (and) or OU (or)
        }
      ],
      
      // Available filter options
      filterFields: [
        { value: 'mascara', label: 'Máscara' },
        { value: 'descricao', label: 'Descrição' },
        { value: 'saldo_anterior', label: 'Saldo Anterior' },
        { value: 'nat_saldo_anterior', label: 'Nat. Saldo Anterior' },
        { value: 'debito', label: 'Débito' },
        { value: 'credito', label: 'Crédito' },
        { value: 'saldo_final', label: 'Saldo Final' },
        { value: 'nat_saldo_final', label: 'Nat. Saldo Final' },
        { value: 'po', label: 'PO' },
        { value: 'fp', label: 'FP' },
        { value: 'dc', label: 'DC' },
        { value: 'fr', label: 'FR' },
        { value: 'co', label: 'CO' },
        { value: 'nr', label: 'NR' },
        { value: 'nd', label: 'ND' },
        { value: 'fs', label: 'FS' },
        { value: 'ai', label: 'AI' }
      ],
      
      filterOperators: [
        { value: 'equals', label: 'Igual a (=)' },
        { value: 'not_equals', label: 'Diferente de (≠)' },
        { value: 'contains', label: 'Contém' },
        { value: 'not_contains', label: 'Não contém' },
        { value: 'starts_with', label: 'Inicia com' },
        { value: 'ends_with', label: 'Termina com' },
        { value: 'greater_than', label: 'Maior que (>)' },
        { value: 'greater_equal', label: 'Maior ou igual (≥)' },
        { value: 'less_than', label: 'Menor que (<)' },
        { value: 'less_equal', label: 'Menor ou igual (≤)' },
        { value: 'is_null', label: 'É nulo ou vazio' },
        { value: 'is_not_null', label: 'Não é nulo e não vazio' }
      ],
      

      // Pagination
      currentPage: 1,
      pageSize: 100,
      
      // Component descriptions modal
      showComponentModal: false,
      componentModalTitle: '',
      componentModalDescription: '',
      componentModalPosition: { top: 0, left: 0 },
      componentModalTimeout: null,
      
      // Streaming export progress
      isStreamingExport: false,
      exportProgress: {
        show: false,
        message: 'Iniciando exportação...',
        isComplete: false
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    hasActiveFilters() {
      return this.searchTerm || this.hasValidFilters;
    },
    activeFiltersCount() {
      let count = 0;
      if (this.searchTerm) count++;
      count += this.dynamicFilters.filter(filter => 
        filter.field && filter.operator && (filter.value || this.isNullOperator(filter.operator))
      ).length;
      return count;
    },
    hasValidFilters() {
      return this.dynamicFilters.some(filter => 
        filter.field && filter.operator && (filter.value || this.isNullOperator(filter.operator))
      );
    }
  },
  
  beforeUnmount() {
    // Cleanup timeouts
    this.clearModalTimeout();
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  
  async created() {
    try {
      await this.validateToken();
      this.checkUserEntidade();

      // Check admin access
      if (!this.user) {
        this.$router.push("/");
        return;
      }

      await this.initializeData();
    } catch (error) {
      console.error("Error initializing balancetes view:", error);
      this.handleUnauthenticated();
    }
  },
  

  methods: {
    ...mapActions(["validateToken", "showToast"]),

    async initializeData() {
      const userEntidade = Cookies.get("user-entidade");
      const cookieString = userEntidade.split(`j:`)[1];
      const userEntidadeJson = JSON.parse(cookieString);
      this.codigoSiconfi = userEntidadeJson.codigo_siconfi;
      this.cidadeSelected = userEntidadeJson.cidade;

      await this.loadAvailableYears();
      this.isLoadingPage = false;
    },

    async loadAvailableYears() {
      try {
        const response = await axiosApi.get(
          `/api/balancetes/${this.codigoSiconfi}/years`,
          {
            withCredentials: true,
          }
        );

        if (response.data.success) {
          this.availableYears = response.data.data;
        }
      } catch (error) {
        console.error("Error loading available years:", error);
        this.showToast({
          title: "Erro",
          message: "Erro ao carregar anos disponíveis",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      }
    },

    async selectYear(year) {
      this.exercicio = year;
      this.exercicioSelected = true;
      this.isLoading = true;

      try {
        await this.loadAvailableMonths();
        
        // Auto-select the highest month available
        if (this.availableMonths.length > 0) {
          this.mes = this.availableMonths[0].value; // First item is highest due to DESC order
          await this.loadBalancetes();
        }
      } catch (error) {
        console.error("Error loading year data:", error);
        this.showToast({
          title: "Erro",
          message: "Erro ao carregar dados do exercício",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async loadBalancetes() {
      try {
        const params = {
          ano: this.exercicio,
          mes: this.mes,
          page: this.currentPage,
          limit: this.pageSize,
          search: this.searchTerm,
        };

        // Add dynamic filters
        if (this.hasValidFilters) {
          params.dynamicFilters = JSON.stringify(this.buildDynamicFiltersForAPI());
        }

        const response = await axiosApi.get(
          `/api/balancetes/${this.codigoSiconfi}/data`,
          {
            params,
            withCredentials: true,
          }
        );

        if (response.data.success) {
          this.balancetes = response.data.data;
          this.pagination = response.data.pagination;
        }
      } catch (error) {
        console.error("Error loading balancetes:", error);
        throw error;
      }
    },

    async loadAvailableMonths() {
      try {
        const response = await axiosApi.get(
          `/api/balancetes/${this.codigoSiconfi}/months`,
          {
            params: { ano: this.exercicio },
            withCredentials: true,
          }
        );

        if (response.data.success) {
          // Convert months to objects with labels and sort DESC
          this.availableMonths = response.data.data
            .map(month => ({
              value: month.toString().padStart(2, '0'),
              label: this.getMonthLabel(month)
            }))
            .sort((a, b) => parseInt(b.value) - parseInt(a.value)); // DESC order
        }
      } catch (error) {
        console.error("Error loading available months:", error);
        this.showToast({
          title: "Erro",
          message: "Erro ao carregar meses disponíveis",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      }
    },

    getMonthLabel(month) {
      const months = {
        1: "Janeiro",
        2: "Fevereiro", 
        3: "Março",
        4: "Abril",
        5: "Maio",
        6: "Junho",
        7: "Julho",
        8: "Agosto",
        9: "Setembro",
        10: "Outubro",
        11: "Novembro",
        12: "Dezembro",
        13: "Encerramento"
      };
      return `${month.toString().padStart(2, '0')} - ${months[month] || 'Mês inválido'}`;
    },

    async onMonthChange() {
      if (this.mes) {
        this.isLoading = true;
        try {
          this.currentPage = 1; // Reset to first page
          await this.loadBalancetes();
        } catch (error) {
          this.showToast({
            title: "Erro",
            message: "Erro ao carregar dados do mês",
            type: "toast-danger",
            headerClass: "toast-header-danger",
          });
        } finally {
          this.isLoading = false;
        }
      }
    },


    // Search and filtering
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.applyDynamicFilters();
      }, 300);
    },

    debounceFilterChange() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.applyDynamicFilters();
      }, 500);
    },

    async applyDynamicFilters() {
      this.isLoading = true;
      try {
        await this.loadBalancetes();
      } catch (error) {
        this.showToast({
          title: "Erro",
          message: "Erro ao aplicar filtros",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    clearDynamicFilters(skipApiCall = false) {
      this.searchTerm = "";
      this.dynamicFilters = [
        {
          id: Date.now(),
          field: '',
          operator: '',
          value: '',
          junction: 'E'
        }
      ];
      this.currentPage = 1;
      
      if (!skipApiCall) {
        this.applyDynamicFilters();
      }
    },

    // Dynamic filter management
    addFilter() {
      this.dynamicFilters.push({
        id: Date.now(),
        field: '',
        operator: '',
        value: '',
        junction: 'E'
      });
    },

    removeFilter(index) {
      if (this.dynamicFilters.length > 1) {
        this.dynamicFilters.splice(index, 1);
        this.applyDynamicFilters();
      }
    },

    onFilterFieldChange(filter) {
      // Reset operator and value when field changes
      filter.operator = '';
      filter.value = '';
    },

    getAvailableOperators(field) {
      if (!field) return [];
      
      // Numeric fields support different operators
      const numericFields = ['saldo_anterior', 'debito', 'credito', 'saldo_final'];
      
      if (numericFields.includes(field)) {
        return this.filterOperators;
      } else {
        // Text fields support subset of operators
        return this.filterOperators.filter(op => 
          ['equals', 'not_equals', 'contains', 'not_contains', 'starts_with', 'ends_with', 'is_null', 'is_not_null'].includes(op.value)
        );
      }
    },

    isNullOperator(operator) {
      return ['is_null', 'is_not_null'].includes(operator);
    },

    buildDynamicFiltersForAPI() {
      return this.dynamicFilters
        .filter(filter => filter.field && filter.operator && (filter.value || this.isNullOperator(filter.operator)))
        .map(filter => ({
          field: filter.field,
          operator: filter.operator,
          value: filter.value,
          junction: filter.junction
        }));
    },

    buildFilterPreview() {
      const validFilters = this.dynamicFilters.filter(filter => 
        filter.field && filter.operator && (filter.value || this.isNullOperator(filter.operator))
      );

      if (validFilters.length === 0) return '';

      let preview = '';
      
      validFilters.forEach((filter, index) => {
        if (index > 0) {
          preview += ` ${filter.junction} `;
        }
        
        const fieldLabel = this.filterFields.find(f => f.value === filter.field)?.label || filter.field;
        const operatorLabel = this.filterOperators.find(o => o.value === filter.operator)?.label || filter.operator;
        
        if (this.isNullOperator(filter.operator)) {
          preview += `${fieldLabel} ${operatorLabel}`;
        } else {
          preview += `${fieldLabel} ${operatorLabel} "${filter.value}"`;
        }
      });

      return preview;
    },

    // Pagination
    async goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages) return;
      this.currentPage = page;
      this.isLoading = true;
      try {
        await this.loadBalancetes();
      } catch (error) {
        this.showToast({
          title: "Erro",
          message: "Erro ao carregar página",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    changePageSize() {
      this.currentPage = 1;
      this.applyDynamicFilters();
    },

    getVisiblePages() {
      const total = this.pagination.totalPages;
      const current = this.pagination.page;
      const delta = 2;

      let start = Math.max(1, current - delta);
      let end = Math.min(total, current + delta);

      if (end - start < 2 * delta) {
        if (start === 1) {
          end = Math.min(total, start + 2 * delta);
        } else {
          start = Math.max(1, end - 2 * delta);
        }
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    // Export functionality
    async exportData() {
      try {
        this.isLoading = true;

        const params = {
          ano: this.exercicio,
          mes: this.mes,
          format: "csv",
        };

        if (this.searchTerm) {
          params.search = this.searchTerm;
        }

        // Add dynamic filters
        if (this.hasValidFilters) {
          params.dynamicFilters = JSON.stringify(this.buildDynamicFiltersForAPI());
        }

        const response = await axiosApi.get(
          `/api/balancetes/${this.codigoSiconfi}/export`,
          {
            params,
            responseType: "blob",
            withCredentials: true,
          }
        );

        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `balancetes_${this.codigoSiconfi}_${this.exercicio}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.showToast({
          title: "Sucesso",
          message: "Dados exportados com sucesso",
          type: "toast-success",
          headerClass: "toast-header-success",
        });
      } catch (error) {
        console.error("Error exporting data:", error);
        this.showToast({
          title: "Erro",
          message: "Erro ao exportar dados",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    // Streaming Export functionality using Fetch API
    async streamExportData() {
      try {
        this.isStreamingExport = true;
        this.exportProgress.show = true;
        this.exportProgress.message = 'Iniciando exportação...';
        this.exportProgress.isComplete = false;

        // Build URL parameters using URLSearchParams
        const params = new URLSearchParams({
          ano: this.exercicio,
        });

        if (this.mes) {
          params.append('mes', this.mes);
        }

        if (this.searchTerm) {
          params.append('search', this.searchTerm);
        }

        // Add dynamic filters
        if (this.hasValidFilters) {
          params.append('dynamicFilters', JSON.stringify(this.buildDynamicFiltersForAPI()));
        }

        this.exportProgress.message = 'Conectando ao servidor...';
        
        // Use the same baseURL logic as axios configuration
        const baseURL = process.env.VUE_APP_BASE_URL;
        
        const response = await fetch(`${baseURL || ''}/api/balancetes/${this.codigoSiconfi}/stream-export?${params}`, {
          method: 'GET',
          credentials: 'include', // Include cookies for authentication
          headers: {
            'Accept': 'text/csv',
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.exportProgress.message = 'Recebendo dados do servidor...';

        // Get the response as a blob for download
        // TODO: For future enhancement, add progress tracking:
        // const reader = response.body.getReader();
        // const contentLength = +response.headers.get('Content-Length');
        // let receivedLength = 0;
        // const chunks = [];
        // while(true) {
        //   const {done, value} = await reader.read();
        //   if(done) break;
        //   chunks.push(value);
        //   receivedLength += value.length;
        //   this.exportProgress.message = `Recebendo: ${Math.round(receivedLength/1024)}KB`;
        // }
        // const blob = new Blob(chunks);
        
        const blob = await response.blob();
        
        this.exportProgress.message = 'Preparando download...';

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `balancetes_${this.codigoSiconfi}_${this.exercicio}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.exportProgress.message = 'Download concluído!';
        this.exportProgress.isComplete = true;

        // Hide progress after delay
        setTimeout(() => {
          this.exportProgress.show = false;
        }, 3000);
        
      } catch (error) {
        console.error("Error in streaming export:", error);
        
        // Show more specific error message
        let errorMessage = 'Erro na exportação!';
        if (error.message.includes('HTTP error')) {
          errorMessage = `Erro HTTP: ${error.message}`;
        } else if (error.name === 'TypeError') {
          errorMessage = 'Erro de conexão. Verifique sua internet.';
        } else if (error.message.includes('timeout')) {
          errorMessage = 'Tempo limite excedido. Tente novamente.';
        }
        
        this.exportProgress.message = errorMessage;
        this.exportProgress.isComplete = true;

        // Hide progress after delay
        setTimeout(() => {
          this.exportProgress.show = false;
        }, 5000); // Longer delay to read error message

      } finally {
        this.isStreamingExport = false;
      }
    },

    // Navigation
    goBack() {
      this.exercicioSelected = false;
      this.exercicio = "";
      this.mes = "";
      this.availableMonths = [];
      this.balancetes = [];
      this.pagination = null;
      this.clearDynamicFilters(true); // Skip API call when going back
    },

    async refreshData() {
      this.isLoading = true;
      try {
        await this.loadBalancetes();

        this.showToast({
          title: "Sucesso",
          message: "Dados atualizados",
          type: "toast-success",
          headerClass: "toast-header-success",
        });
      } catch (error) {
        this.showToast({
          title: "Erro",
          message: "Erro ao atualizar dados",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    // Utility methods
    checkUserEntidade() {
      if (!this.$store.state.userEntidade) {
        this.$router.push("/selecaoEntidades");
      }
    },

    handleUnauthenticated() {
      this.$router.push("/login");
    },

    formatCurrency(value) {
      if (!value) return "R$ 0,00";
      const num = parseFloat(value);
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(num);
    },

    formatNumber(value) {
      if (!value) return "0";
      return new Intl.NumberFormat("pt-BR").format(value);
    },

    truncateText(text, maxLength) {
      if (!text) return "";
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + "...";
    },
    
    async showComponentDescription(event, component, value) {
      console.log('showComponentDescription called:', { component, value, event });
      if (!value) return;
      
      // Set initial modal content and position
      const componentNames = {
        "PO": "Poder e Órgão",
        "FP": "Atributo do Superávit Financeiro",
        "DC": "Dívida Consolidada",
        "FR": "Fonte ou Destinação de Recursos",
        "CO": "Cód. de Acom. da Exec. Orçamentária",
        "NR": "Natureza da Receita",
        "ND": "Natureza da Despesa",
        "FS": "Classificação Funcional",
        "AI": "Ano de Inscrição de Restos",
      }

      this.componentModalTitle = `${componentNames[component.toUpperCase()]}`;
      this.componentModalDescription = 'Carregando descrição...';
      
      // Position the modal on top of the clicked element
      const rect = event.target.getBoundingClientRect();
      this.componentModalPosition = {
        top: rect.bottom, // Bottom edge of the element (no margin)
        left: rect.left + (rect.width / 2) // Center horizontally
      };
      
      this.showComponentModal = true;
      
      // Clear any existing timeout when showing modal
      this.clearModalTimeout();
      
      try {
        // Call the API to get the real description
        const response = await axiosApi.get('/api/component-descriptions', {
          params: {
            ano: this.exercicio,
            componente: component,
            valor: value
          },
          withCredentials: true
        });
        
        if (response.data.success) {
          this.componentModalDescription = `${value} - ${response.data.data.descricao}`;
        } else {
          this.componentModalDescription = value;
        }
      } catch (error) {
        console.error('Error fetching component description:', error);
        if (error.response && error.response.status === 404) {
          this.componentModalDescription = value;
        } else {
          this.componentModalDescription = 'Erro ao carregar descrição. Tente novamente.';
        }
      }
    },
    
    closeComponentModal() {
      console.log(this.showComponentModal)
      console.log('Closing modal');
      this.clearModalTimeout();
      this.showComponentModal = false;
    },
    
    startModalTimeout() {
      this.clearModalTimeout();
      this.componentModalTimeout = setTimeout(() => {
        this.closeComponentModal();
      }, 3000); // 3 seconds delay
    },
    
    clearModalTimeout() {
      if (this.componentModalTimeout) {
        clearTimeout(this.componentModalTimeout);
        this.componentModalTimeout = null;
      }
    }
  },
};
</script>

<style scoped>
.balancetes-header {
  background: white;
  padding: 1rem 2rem;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.year-selection {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.data-section {
  padding: 0 2rem 2rem;
}

.table-responsive {
  max-height: 70vh;
  overflow-y: auto;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item-action:hover {
  background-color: var(--azul-claro);
  color: white;
}

.pagination .page-link {
  border-color: #dee2e6;
  color: #495057;
}

.pagination .page-item.active .page-link {
  background-color: var(--azul-escuro);
  border-color: var(--azul-escuro);
}

.pagination .page-link:hover {
  background-color: var(--azul-claro);
  border-color: var(--azul-claro);
  color: white;
}

.form-select:focus,
.form-control:focus {
  border-color: var(--azul-final);
  box-shadow: 0 0 0 0.2rem rgba(var(--azul-final-rgb), 0.25);
}

.btn-secondary {
  background-color: var(--azul-escuro);
  border-color: var(--azul-escuro);
}

.btn-secondary:hover {
  background-color: var(--azul-final);
  border-color: var(--azul-final);
}

.btn-outline-secondary {
  color: var(--azul-escuro);
  border-color: var(--azul-escuro);
}

.btn-outline-secondary:hover {
  background-color: var(--azul-escuro);
  border-color: var(--azul-escuro);
  color: white;
}

/* Compact table styling */
.table-compact {
  font-size: 0.8rem;
}

/* Override Bootstrap table margin-top for this component only */
.table {
  margin-top: 0 !important;
}

.table-compact th {
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.table-compact td {
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  line-height: 1.3;
}

.table-compact code {
  background: #f8f9fa;
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.75rem;
  color: #495057;
}

.table-compact small {
  font-size: 0.7rem;
}

.badge-compact {
  font-size: 0.65rem;
  padding: 0.2rem 0.4rem;
}

.badge.bg-light {
  background-color: #f8f9fa !important;
  color: #495057 !important;
}

/* Mascara code styling */
.mascara-code {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.75rem;
  background: #f8f9fa;
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
  color: #495057;
}

/* Info icon styling */
.info-icon {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
  color: #007bff !important;
}

/* Enhanced tooltip styling for info icon */
.info-icon[title]:hover::after {
  content: attr(title);
  position: absolute;
  background: #333;
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  white-space: nowrap;
  z-index: 1000;
  top: -2.5rem;
  left: 50%;
  transform: translateX(-50%);
  max-width: 300px;
  word-wrap: break-word;
  white-space: normal;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  pointer-events: none;
}

/* Arrow for custom tooltip */
.info-icon[title]:hover::before {
  content: '';
  position: absolute;
  top: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #333;
  z-index: 1001;
  pointer-events: none;
}

/* Compact table adjustments */
.table-compact th,
.table-compact td {
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.table-compact th:first-child,
.table-compact td:first-child {
  white-space: normal;
  overflow: visible;
  text-overflow: initial;
}

/* Ensure consistent row heights */
.table-compact tr {
  height: 2.2rem;
}

.table-compact td {
  vertical-align: middle;
}

/* Reduce spacing between monetary values and nat_saldos */
.table-compact th:nth-child(11),
.table-compact td:nth-child(11) {
  padding-right: 0.25rem !important;
}

.table-compact th:nth-child(12),
.table-compact td:nth-child(12) {
  padding-left: 0.25rem !important;
  padding-right: 0.5rem !important;
}

.table-compact th:nth-child(15),
.table-compact td:nth-child(15) {
  padding-right: 0.25rem !important;
}

.table-compact th:nth-child(16),
.table-compact td:nth-child(16) {
  padding-left: 0.25rem !important;
}

/* Component button styling */
.component-btn {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.7rem;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;
}

.component-btn:hover {
  color: #0056b3;
  text-decoration: none;
}

.component-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  border-radius: 2px;
}

/* Component modal styling */
.component-modal {
  position: fixed;
  z-index: 1060;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  min-width: 250px;
  max-width: 400px;
  transform: translateX(-50%);
  animation: fadeInUp 0.2s ease-out;
}

.component-modal-close {
  position: absolute;
  right: 0px;
}

.component-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
  border-radius: 0.375rem 0.375rem 0 0;
}

.component-modal-header h6 {
  color: #495057;
  font-weight: 600;
  font-size: 0.8rem;
}

.btn-close-modal {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: background-color 0.2s ease;
}

.btn-close-modal:hover {
  background-color: #e9ecef;
  color: #495057;
}

.component-modal-body {
  padding: 1rem;
  color: #495057;
  font-size: 0.8rem;
  line-height: 1.3;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Export Progress Overlay */
.export-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.export-progress-modal {
  background: white;
  border-radius: var(--radius-md);
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: var(--shadow-lg);
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
